/**
 * View Switcher — Rugtales Collection
 * Switches all product cards between Freisteller (product) and Moodbild (room) view.
 * State is persisted in localStorage so the preference survives pagination.
 */

const STORAGE_KEY = 'rt_view_mode';
const MOOD_MODE   = 'mood';
const PRODUCT_MODE = 'product';

class ViewSwitcher extends HTMLElement {
  connectedCallback() {
    this._productList = document.getElementById(this.dataset.controls);
    this._buttons     = this.querySelectorAll('[data-view]');

    // Restore persisted preference on load
    const saved = localStorage.getItem(STORAGE_KEY) || PRODUCT_MODE;
    this._apply(saved, false); // no animation on first paint

    this._buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        // stopImmediatePropagation: prevents both bubbling AND other listeners
        // on the same button from firing (e.g. collection-layout-switch internals).
        e.stopImmediatePropagation();
        this._apply(btn.dataset.view, true);
      });
    });
  }

  _apply(mode, animate) {
    if (!this._productList) return;

    if (animate) {
      this._productList.classList.add('view-switcher--transitioning');
      this._productList.addEventListener(
        'transitionend',
        () => this._productList.classList.remove('view-switcher--transitioning'),
        { once: true }
      );
    }

    if (mode === MOOD_MODE) {
      this._productList.classList.add('view-mode--mood');
    } else {
      this._productList.classList.remove('view-mode--mood');
    }

    this._buttons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.view === mode);
      btn.setAttribute('aria-pressed', btn.dataset.view === mode ? 'true' : 'false');
    });

    localStorage.setItem(STORAGE_KEY, mode);
  }
}

if (!customElements.get('view-switcher')) {
  customElements.define('view-switcher', ViewSwitcher);
}
